module.exports = __webpack_public_path__ + "img/solution-zuanjing.9f5ab1d5.jpg";